import React from 'react';
import ChecklistTile from '../../../../../incase-domain/components/checkbox/ChecklistTile';
import {capitalize} from '../../../../../utils/utils';

export function StringArrayFilterControl({
    value = [],
    options = [],
    onChange,
}: {
    value?: string[];
    options?: string[];
    onChange: (next: string[]) => void;
}): JSX.Element {
    const selected = value ?? [];

    const toggleItem = (item: string): void => {
        const next = selected.includes(item) ? selected.filter((i) => i !== item) : [...selected, item];
        onChange(next);
    };

    if (!options?.length) {
        return <></>;
    }

    return (
        <div className="u-flex u-flex-col u-gap-2">
            {options.map((option) => (
                <ChecklistTile
                    color="primary"
                    key={option}
                    label={capitalize(option.toLowerCase())}
                    value={selected.includes(option)}
                    onChange={() => toggleItem(option)}
                />
            ))}
        </div>
    );
}
